<template>
  <div class="bottom_tree_table">
    <div class="bottom_left">
      <major-tree :type="1" @detailBtn="detailBtn"></major-tree>
    </div>
    <div class="bottom_right">
      <div class="right_button">
        <span>模板列表</span>
        <el-upload ref="upload" :disabled="upload" :show-file-list="false" :http-request="httpRequest" multiple
          class="upload-file" style="display: inline-block;" action="/" accept=".dwg">
          <el-button v-if="uploadFloder" type="primary" size="small" @click="upLoadFile">
            上传
          </el-button>
        </el-upload>
      </div>
      <div class="right_table">
        <el-table ref="table" :data="fileTable" border highlight-current-row height="100%">
          <template slot="empty">
            <img :src="zanwu" alt="" />
            <p style="font-size: 16px; color: #000; margin-top: 36px">
              暂无数据
            </p>
          </template>
          <el-table-column label="序号" type="index" width="60" />
          <el-table-column label="文件名称" prop="fileName" min-width="200px">
            <template #default="{ row }">
              <el-link v-if="renameFloder" type="primary" @click="renameBtn(row)">
                <span class="tabLinkSpan" :title="row.fileName">{{ row.fileName }}</span>
              </el-link>
              <span v-else class="tabLinkSpan" :title="row.fileName">{{ row.fileName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建人" prop="operatorName" min-width="120px" />
          <el-table-column label="上传时间" prop="uploadTime" min-width="120px" />
          <el-table-column label="最近更新时间" prop="updateTime" min-width="120px" />
          <el-table-column label="备注" prop="remark" min-width="120px" />
          <el-table-column v-if="downFloder||renameFloder||deleFloder||editFloder" label="操作" align="center" min-width="160px">
            <template slot-scope="scope">
              <span v-if="downFloder" class="btn" @click="downloadFile(scope.row)">下载</span>
              <span v-if="renameFloder" class="btn" @click="renameBtn(scope.row)">重命名</span>
              <span v-if="deleFloder" class="btn" @click="deleteBtn(scope.row)">删除</span>
              <span v-if="editFloder" class="btn" @click="changeFileRemark(scope.row)">修改备注</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import majorTree from "@/CommonDP/components/structure/majorTree.vue";
import standardTemplateService from "@/CommonDP/service/standardTemplate-service";
import { checkPermission, disablePrompt } from "@/CommonDP/utils/routeAuth";

import { mapState } from "vuex";
export default {
  name: "StandardTemplate",
  components: { majorTree },
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      fileTable: [],
      upload: false,
      status: 0,
      currentTypeID: undefined, // 树选中id
      deleFloder: checkPermission(this.$allPerms.STANDARDTEMPLATE_DALE),
      uploadFloder: checkPermission(this.$allPerms.STANDARDTEMPLAT_UPLOAD),
      downFloder: checkPermission(this.$allPerms.STANDARDTEMPLAT_DOWN),
      renameFloder: checkPermission(this.$allPerms.STANDARDTEMPLAT_RENAME),
      editFloder: checkPermission(this.$allPerms.STANDARDTEMPLAT_EDIT)
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    })
  },

  methods: {
    detailBtn(val) {
      this.currentTypeID = val.specId;
      this.selectDocumentList(val.specId);
    },
    // 列表
    async selectDocumentList(specId) {
      this.fileTable = [];
      const res = await standardTemplateService.selectDocumentList({
        fileId: specId,
        standardType: 10,
        enterpriseId: this.enterpriseId
      });
      this.fileTable = res.data || [];
    },
    upLoadFile() {
      const a = disablePrompt();
      if (!a) {
        this.upload = true;
      }
    },
    // 右侧上传
    async httpRequest({ file }) {
      const data = new FormData();
      data.append("file", file);
      data.append("enterpriseId", this.enterpriseId);
      data.append("typeID", this.currentTypeID);
      try {
        this.upload = true;
        await standardTemplateService.uploadStandardDocument(data, {
          timeout: 0,
          onUploadProgress: ({ loaded, total }) => {
            this.status = ~~((loaded / total) * 100);
          }
        });
        this.selectDocumentList(this.currentTypeID);
      } finally {
        this.upload = false;
      }
    },
    // 右侧下载
    async downloadFile(row) {
      const a = disablePrompt();
      if (a) {
        standardTemplateService.downloadStandardDocument(row.fileId).then(response => {
          if (response.type === "application/json") {
            const fileReader = new FileReader();
            fileReader.onloadend = () => {
              const jsonData = JSON.parse(fileReader.result);
              // 后台信息
              this.$message({ message: jsonData.message, type: "error" });
            };
            fileReader.readAsText(response); // 或者读取response.data
          } else {
            const link = document.createElement("a");
            const blob = new Blob([response], {
              type: "application/octet-stream"
            });
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", decodeURI(row.fileName));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        });
      }
    },
    // 右侧删除
    async deleteBtn(row) {
      const a = disablePrompt();
      if (a) {
        await this.$confirm(`您确定要删除文件${row.fileName}吗，是否继续？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        const res = await standardTemplateService.deleteStandardDocument({
          fileId: row.fileId
        });
        if (res.result === "0") {
          this.$message({ message: "删除成功", type: "success" });
        }
        this.selectDocumentList(this.currentTypeID);
      }
    },
    // 右侧修改
    changeFileRemark(row) {
      const a = disablePrompt();
      if (a) {
        const name = row.remark;
        const { $prompt } = this;
        $prompt("备注", "备注", {
          inputPlaceholder: "请输入备注",
          inputValue: name,
          inputErrorMessage: "请输入除空格外的200文字以内的备注",
          inputPattern: /^\S{1,200}$/,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          beforeClose: (action, { inputValue }, done) => {
            if (action !== "confirm") return done();
            standardTemplateService
              .renameStandardDocument({
                fileID: row.fileId,
                remark: inputValue,
                fileName: row.fileName
              })
              .then(data => {
                if (data.result === "0") {
                  this.$message({
                    message: "修改成功",
                    type: "success"
                  });
                  this.selectDocumentList(this.currentTypeID);
                } else {
                  this.$message({
                    message: "修改失败",
                    type: "warning"
                  });
                }
                done();
              })
              .then(() => {
                done();
              });
          }
        });
      }
    },
    // 右侧重命名
    renameBtn(row) {
      const a = disablePrompt();
      if (a) {
        const { $prompt } = this;
        const reg = /\.[\w\d]+?$/;
        const reNameStr = row.fileName.replace(reg, "");
        const extName = row.fileName.slice(reNameStr.length);
        $prompt("请输入文件名称", "编辑文件名称", {
          inputPlaceholder: "输入文件名称",
          inputValue: reNameStr,
          inputErrorMessage: "请输入除空格外的100文字以内的文件名称",
          inputPattern: /^\S{1,100}$/,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          beforeClose: (action, { inputValue }, done) => {
            if (action === "confirm") {
              standardTemplateService
                .renameStandardDocument({
                  fileID: row.fileId,
                  fileName: inputValue + extName
                })
                .then(data => {
                  if (data.result === "0") {
                    this.$message({
                      showClose: true,
                      type: "success",
                      message: "修改成功"
                    });
                  }
                  this.selectDocumentList(this.currentTypeID);
                  done();
                });
            } else {
              done();
            }
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
$left_width: 256px;
$top_height: 35px;
$minddle_height: 40px;
.bottom_tree_table {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  .bottom_left {
    position: absolute;
    top: 10px;
    bottom: 0;
    left: 10px;
    width: $left_width;
    border-right: 1px solid #ebefff;
  }
  .bottom_right {
    position: relative;
    height: 100%;
    margin-left: $left-width + 10px;
    display: flex;
    flex-direction: column;
    .right_button {
      padding: var(--middle-space) var(--big-space);
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #ebefff;
      span {
        font-size: 16px;
        font-weight: 600;
        color: var(--key-color);
      }
    }
    .right_table {
      padding: var(--middle-space) var(--big-space);
      height: 1px;
      flex-grow: 1;
      .btn {
        cursor: pointer;
        color: var(--theme-color);
        margin-right: 5px;
      }
    }
  }
}
</style>
